import {forwardRef} from "react";

export const SelectIcon = forwardRef<SVGSVGElement>((props, ref) => (
    <svg
      ref={ref}
      {...props}
      width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 7.5L10 12.5L15 7.5" stroke="#A4AABF" strokeWidth="1.5" strokeLinecap="round"
            strokeLinejoin="round"/>
    </svg>
))